const KEY_TAB = 9;
const KEY_ESC = 27;
const defaults = {
    toggleClass: 'search-open'
};

let focusedElBeforeOpen = undefined;
let focusableEls = undefined;
let buttonElement = undefined;
let containerElement = undefined;

const closeSearch = () => {
    document.body.classList.remove(defaults.toggleClass);
    buttonElement.setAttribute('aria-expanded', false);
    containerElement.setAttribute('aria-hidden', true);
    focusedElBeforeOpen.focus();
};

const openSearch = () => {
    document.body.classList.add(defaults.toggleClass);
    buttonElement.setAttribute('aria-expanded', true);
    containerElement.setAttribute('aria-hidden', false);
    focusedElBeforeOpen = document.activeElement;
    focusableEls = containerElement.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    focusableEls = Array.prototype.slice.call(focusableEls);
    focusableEls[0].focus();
};

function handleBackwardTab(e) {
    if (document.activeElement === focusableEls[0]) {
        e.preventDefault();
        focusableEls[0].focus();
    }
}

function handleForwardTab(e) {
    if (document.activeElement === focusableEls[focusableEls.length - 1 ]) {
        e.preventDefault();
        focusableEls[0].focus();
    }
}

const keydownHandler = (e) => {
    if (e.keyCode === KEY_ESC) {
        closeSearch();
    }

    switch (e.keyCode) {
        case KEY_TAB:
            if (e.shiftKey) {
                handleBackwardTab(e);
            } else {
                handleForwardTab(e);
            }
            break;
        default:
            break;
    } // end switch
};

// toggle  body-class
const toggleBodyClass = () => {
    if (document.body.classList.contains(defaults.toggleClass)) {
        closeSearch();
        containerElement.removeEventListener('keydown', keydownHandler);
    } else {
        openSearch();
        containerElement.addEventListener('keydown', keydownHandler);
    }
};

export function init(selector, container = '#search-container') {
    if (!document.querySelector(selector)) {
        return;
    }

    buttonElement = document.querySelector(selector);
    containerElement = document.querySelector(container);

    // clickhandler
    const clickHandler = (e) => {
        e.preventDefault();
        toggleBodyClass();
    };

    // add handlers
    buttonElement.addEventListener('click', clickHandler);
}

export default {
    init
};
